import { CanActivateFn } from '@angular/router';

import { sessionGuard } from '@/core/auth/guards/session.guard';

export const authGuard: CanActivateFn = sessionGuard(() => true);
